import React from "react";
import { AlertCircle, RefreshCw } from "lucide-react";
import { Button } from "@src/lib/ui/Button";
import Text from "@src/lib/ui/Text";
import { cn } from "@src/lib/utils/cn";

export interface ChatErrorMessageProps {
  onRetry?: () => void;
  className?: string;
}

export const ChatErrorMessage: React.FC<ChatErrorMessageProps> = ({
  onRetry,
  className = "",
}) => {
  return (
    <div className={cn(`my-2 w-full`, className)}>
      <div className="flex items-center justify-center gap-3 rounded-lg border border-red-3 bg-red-1 p-4">
        <div className="flex-shrink-0">
          <AlertCircle className="h-5 w-5 text-red-7" />
        </div>
        <div className="flex items-center justify-between gap-4 flex-1 min-w-0">
          <div>
            <div>
              <Text variant="compact-title" className="text-red-9 mb-1">
                Error
              </Text>
            </div>
            <div>
              <Text
                variant="fine-print-description"
                multiline
                className="text-red-8 mb-3"
              >
                Something went wrong with the AI response. Please try again.
              </Text>
            </div>
          </div>
          {onRetry && (
            <Button variant="outline" size="sm" onClick={onRetry}>
              <RefreshCw data-icon="inline-start" />
              Try again
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ChatErrorMessage;
